var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    fill: "#ffffff",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-To-refresh",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 8.000000)",
    stroke: "#ffffff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89,40 C89,17.90861 71.09139,0 49,0 C34.1239759,0 21.1446258,8.12062657 14.2530697,20.1707596",
    id: "Layer-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Layer-2",
    transform: "translate(89.000000, 37.000000) scale(1, -1) rotate(11.000000) translate(-89.000000, -37.000000) ",
    points: "79 42 89 32 99 42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,84 C91,61.90861 73.09139,44 51,44 C36.1239759,44 23.1446258,52.1206266 16.2530697,64.1707596",
    id: "Layer-3",
    transform: "translate(51.000000, 64.000000) scale(-1, -1) translate(-51.000000, -64.000000) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Layer-4",
    transform: "translate(11.000000, 47.000000) scale(-1, 1) rotate(11.000000) translate(-11.000000, -47.000000) ",
    points: "1 52 11 42 21 52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.1c839d87cb27f1e45f1a3bc4a9e300ea.svg";
export { ForwardRef as ReactComponent };